
import { Component, Vue, Prop } from "vue-property-decorator";
import { SMUser } from "@/store";
import HelloWidgetTemplate from "@/components/Widgets/Templates/HelloWidgetTemplate.vue";
import Image from "@/assets/images/people/person-1.png";

@Component({
  components: {
    HelloWidgetTemplate,
  },
})
export default class Hello extends Vue {
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;
  @Prop({ type: String }) readonly caseType?: string;
  @Prop({ type: String }) readonly listType?: string;

  get computedProps() {
    const { jobTitle, name, list, listType } = this;

    return {
      title: this.$tc("title"),
      jobTitle,
      name,
      list,
      listType,
      tasksEnable: true,
      image: Image,
    };
  }

  get list() {
    const { caseType } = this;
    const role = SMUser.user?.role;

    if (!role) return [];

    const path = `list.${caseType}.${role}`;

    return this.$t(path) || [];
  }
}
